import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import Api from '../services/api/api'
import useNitroViewport from '../customHooks/nitroHooks';
import Home from './Home';
import Splash from './Splash';
import SplashMobile from './SplashMobile';
import Survey from './Survey';
import PageNotFound from './PageNotFound';

import sampleData from '../nitro-json.json';
import { v4 as uuidv4 } from 'uuid';

let sessionID = uuidv4();

const SurveyWrapper = () => {

  let { uid } = useParams();
  const [error, setError] = useState(null);
  const [surveyQuestions, setSurveyQuestions] = useState();

  useEffect(() => {
    if (uid) {
      let resourceApi = new Api();
      resourceApi.get('survey/' + uid)
        .then(res => res.json())
        .then((response) => {
          console.log('response from api', response);
          if (response && response.success === "success" && response.payload) {
            setSurveyQuestions(response.payload);
          } else {
            setError('404');
          }
        })
        .catch((error) => {
          console.warn(error);
          setError('404');
        });
    }

  },[uid]);

  if (!uid) {
    return <Home/>
  } else if (uid == 'sample') {
    return <SplashSwitcher uid={uid} qData={sampleData.payload} />
  } else {

    if (surveyQuestions) {
       return <SplashSwitcher uid={uid} qData={surveyQuestions} />
    } else if (error) {
      return <PageNotFound />
    }

  }

}

const SplashSwitcher = ({uid, qData}) => {

  const [showSplash, setShowSplash] = useState(true);

  const propColorVar = (varName, hexColor) => {
    return document.documentElement.style.setProperty(varName, hexColor);
  }

  useEffect(() => {
    if (qData) {
      propColorVar('--pageStyle1-main', qData.theme.pageStyle1.main)
      propColorVar('--pageStyle1-textColor', qData.theme.pageStyle1.textColor)
      propColorVar('--pageStyle1-hint1', qData.theme.pageStyle1.hint1)
      propColorVar('--pageStyle1-hint2', qData.theme.pageStyle1.hint2)

      propColorVar('--pageStyle2-main', qData.theme.pageStyle2.main)
      propColorVar('--pageStyle2-textColor', qData.theme.pageStyle2.textColor)
      propColorVar('--pageStyle2-hint1', qData.theme.pageStyle2.hint1)
      propColorVar('--pageStyle2-hint2', qData.theme.pageStyle2.hint2)

      propColorVar('--pageStyle3-main', qData.theme.pageStyle3.main)
      propColorVar('--pageStyle3-textColor', qData.theme.pageStyle3.textColor)
      propColorVar('--pageStyle3-hint1', qData.theme.pageStyle3.hint1)
      propColorVar('--pageStyle3-hint2', qData.theme.pageStyle3.hint2)
    }

  }, []);

  const { width } = useNitroViewport();
  const breakpoint = 768;
  let ComponentToRender = width < breakpoint ? SplashMobile:Splash
  if (showSplash) {
    return <ComponentToRender setShowSplash={setShowSplash} qData={qData} />
  } else {
    return <Survey sessionID={sessionID} uid={uid} qData={qData} />
  }

}

export default SurveyWrapper;
